import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@constants/queryKey';
import { fetchCurrentUser } from '@repository/userRepository';
import { minutesToMillis } from '@utils/millis';
import { useIsAuthenticated } from '@azure/msal-react';
import { FetchCurrentUserError, FetchCurrentUserResponse } from '@models/user/FetchCurrentUser';
import useAuthentication from '@hooks/useAuthentication';

const useFetchCurrentUser = () => {
    const isAuthenticated = useIsAuthenticated();
    const { getAccessToken } = useAuthentication();
    const accessToken = getAccessToken();

    return useQuery<FetchCurrentUserResponse, FetchCurrentUserError>({
        queryKey: [QueryKey.Profile],
        queryFn: ({ signal }) => fetchCurrentUser({ signal }),
        enabled: isAuthenticated || !!accessToken,
        staleTime: minutesToMillis(30),
        retry: (failureCount: number, error) => {
            if (error?.response?.status === 401) return false;
            return failureCount <= 3;
        },
    });
};

export default useFetchCurrentUser;
